export default "__VITE_ASSET__CDfM$IjX__"